import React from 'react';
import { SurveyQuestion } from './SurveyQuestion';

export const SurveyCheckbox = ({ option, hasVoted, onOptionUpdated }) => {
    const handleSelect = (event) => {
        onOptionUpdated(option.ballotOptionId, event.target.value)
    };

    return (
        <React.Fragment>
            <SurveyQuestion option={option} />
            <div className="inline-flex flex-wrap">
                {option.surveyOptions.map((surveyOption) =>
                    <div key={surveyOption} className="pr-4 pb-4">
                        <input type="radio"
                            id={surveyOption}
                            value={surveyOption}
                            name={option.ballotOptionId}
                            disabled={hasVoted}
                            checked={option.textValue === surveyOption}
                            onChange={handleSelect} />
                        <label htmlFor={surveyOption}
                            className="cursor-pointer disabled:cursor-default">{surveyOption}</label>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}